// extracted by mini-css-extract-plugin
export var borderRadius = "_db-4";
export var large = "_db-3";
export var logoContainer = "_db-0";
export var nameLogo = "_db-2";
export var small = "_db-1";